if (customElements.get('tabbed-content') === undefined) {
  class TabedContent extends HTMLElement {
    constructor() {
      super();

      this.tabs = this.querySelectorAll('[role="tab"]');
      if (!this.tabs.length) return;

      this.tabFocus = 0;
      this.tabList = this.querySelector('[role="tablist"]');
      this.tabList.addEventListener('keydown', this.keyEvents.bind(this));
      this.tabs.forEach((tab, i) => { tab.addEventListener('click', this.selectTab.bind(this)) });
    }

    keyEvents() {
      if (event.keyCode != 39 && event.keyCode != 37) return;

      this.tabs[this.tabFocus].setAttribute('tabindex', -1);

      if (event.keyCode === 39) {
        this.tabFocus++;
        if (this.tabFocus >= this.tabs.length) this.tabFocus = 0;

      } else if (event.keyCode === 37) {
        this.tabFocus--;
        if (this.tabFocus < 0) this.tabFocus = this.tabs.length - 1;
      }

      this.tabs[this.tabFocus].setAttribute('tabindex', 0);
      this.tabs[this.tabFocus].focus();
    }

    selectTab() {
      this.activeTab = event.target.closest('[aria-selected]');

      this.querySelectorAll('[aria-selected="true"]').forEach(item => item.setAttribute('aria-selected', false));
      this.activeTab.setAttribute('aria-selected', true);

      this.querySelectorAll('[role="tabpanel"]').forEach(item => item.setAttribute('hidden', true));
      this.querySelector(`#${this.activeTab.getAttribute('aria-controls')}`).removeAttribute('hidden');
    }
  }

  customElements.define('tabbed-content', TabedContent);
}
